var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuthenticatedQrCode(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8822_140257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 0H0V72H72V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2025 4.83596C22.7496 4.83596 23.1931 4.39245 23.1931 3.84535C23.1931 3.29825 22.7496 2.85474 22.2025 2.85474C21.6554 2.85474 21.2119 3.29825 21.2119 3.84535C21.2119 4.39245 21.6554 4.83596 22.2025 4.83596Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7846 4.83596C27.3317 4.83596 27.7752 4.39245 27.7752 3.84535C27.7752 3.29825 27.3317 2.85474 26.7846 2.85474C26.2375 2.85474 25.7939 3.29825 25.7939 3.84535C25.7939 4.39245 26.2375 4.83596 26.7846 4.83596Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6566 4.83596C34.2037 4.83596 34.6472 4.39245 34.6472 3.84535C34.6472 3.29825 34.2037 2.85474 33.6566 2.85474C33.1095 2.85474 32.666 3.29825 32.666 3.84535C32.666 4.39245 33.1095 4.83596 33.6566 4.83596Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5287 4.83596C41.0758 4.83596 41.5193 4.39245 41.5193 3.84535C41.5193 3.29825 41.0758 2.85474 40.5287 2.85474C39.9816 2.85474 39.5381 3.29825 39.5381 3.84535C39.5381 4.39245 39.9816 4.83596 40.5287 4.83596Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.142 2.82368C44.5848 2.82368 44.1514 3.28803 44.1514 3.81429C44.1514 4.37151 44.6157 4.80491 45.142 4.80491H46.2874V2.79272H45.142V2.82368Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4325 4.83596C47.9897 4.83596 48.4231 4.37161 48.4231 3.84535C48.4231 3.28813 47.9588 2.85474 47.4325 2.85474H46.2871V4.83596H47.4325Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2025 7.12673C22.7496 7.12673 23.1931 6.68322 23.1931 6.13612C23.1931 5.58902 22.7496 5.14551 22.2025 5.14551C21.6554 5.14551 21.2119 5.58902 21.2119 6.13612C21.2119 6.68322 21.6554 7.12673 22.2025 7.12673Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0746 7.12673C29.6217 7.12673 30.0652 6.68322 30.0652 6.13612C30.0652 5.58902 29.6217 5.14551 29.0746 5.14551C28.5275 5.14551 28.084 5.58902 28.084 6.13612C28.084 6.68322 28.5275 7.12673 29.0746 7.12673Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9476 7.12673C36.4947 7.12673 36.9383 6.68322 36.9383 6.13612C36.9383 5.58902 36.4947 5.14551 35.9476 5.14551C35.4005 5.14551 34.957 5.58902 34.957 6.13612C34.957 6.68322 35.4005 7.12673 35.9476 7.12673Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8197 7.12673C43.3668 7.12673 43.8103 6.68322 43.8103 6.13612C43.8103 5.58902 43.3668 5.14551 42.8197 5.14551C42.2726 5.14551 41.8291 5.58902 41.8291 6.13612C41.8291 6.68322 42.2726 7.12673 42.8197 7.12673Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.432 7.12673C47.9791 7.12673 48.4226 6.68322 48.4226 6.13612C48.4226 5.58902 47.9791 5.14551 47.432 5.14551C46.8849 5.14551 46.4414 5.58902 46.4414 6.13612C46.4414 6.68322 46.8849 7.12673 47.432 7.12673Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2025 7.40547C21.6453 7.40547 21.2119 7.86982 21.2119 8.39608C21.2119 8.9533 21.6763 9.38669 22.2025 9.38669H23.3479V7.37451H22.2025V7.40547Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4931 9.41775C25.0503 9.41775 25.4837 8.9534 25.4837 8.42714C25.4837 7.86992 25.0193 7.43652 24.4931 7.43652H23.3477V9.44871H24.4931V9.41775Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0746 9.41775C29.6217 9.41775 30.0652 8.97424 30.0652 8.42714C30.0652 7.88003 29.6217 7.43652 29.0746 7.43652C28.5275 7.43652 28.084 7.88003 28.084 8.42714C28.084 8.97424 28.5275 9.41775 29.0746 9.41775Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6566 9.41775C34.2037 9.41775 34.6472 8.97424 34.6472 8.42714C34.6472 7.88003 34.2037 7.43652 33.6566 7.43652C33.1095 7.43652 32.666 7.88003 32.666 8.42714C32.666 8.97424 33.1095 9.41775 33.6566 9.41775Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5287 9.41775C41.0758 9.41775 41.5193 8.97424 41.5193 8.42714C41.5193 7.88003 41.0758 7.43652 40.5287 7.43652C39.9816 7.43652 39.5381 7.88003 39.5381 8.42714C39.5381 8.97424 39.9816 9.41775 40.5287 9.41775Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.432 7.40547C46.8748 7.40547 46.4414 7.86982 46.4414 8.39608C46.4414 8.9533 46.9058 9.38669 47.432 9.38669H48.5774V7.37451H47.432V7.40547Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7235 9.41775C50.2807 9.41775 50.7141 8.9534 50.7141 8.42714C50.7141 7.86992 50.2498 7.43652 49.7235 7.43652H48.5781V9.44871H49.7235V9.41775Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7846 11.7083C27.3317 11.7083 27.7752 11.2648 27.7752 10.7177C27.7752 10.1706 27.3317 9.72705 26.7846 9.72705C26.2375 9.72705 25.7939 10.1706 25.7939 10.7177C25.7939 11.2648 26.2375 11.7083 26.7846 11.7083Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6566 9.696C33.0994 9.696 32.666 10.1603 32.666 10.6866C32.666 11.2438 33.1304 11.6772 33.6566 11.6772H34.802V9.66504H33.6566V9.696Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0925 9.69604H34.8018V11.7082H37.0925V9.69604Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2382 11.7083C38.7954 11.7083 39.2288 11.2439 39.2288 10.7177C39.2288 10.1604 38.7644 9.72705 38.2382 9.72705H37.0928V11.7392H38.2382V11.7083Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8197 9.696C42.2625 9.696 41.8291 10.1603 41.8291 10.6866C41.8291 11.2438 42.2935 11.6772 42.8197 11.6772H43.9651V9.66504H42.8197V9.696Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1415 11.7083C45.6987 11.7083 46.1321 11.2439 46.1321 10.7177C46.1321 10.1604 45.6678 9.72705 45.1415 9.72705H43.9961V11.7392H45.1415V11.7083Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.723 11.7083C50.2701 11.7083 50.7136 11.2648 50.7136 10.7177C50.7136 10.1706 50.2701 9.72705 49.723 9.72705C49.1759 9.72705 48.7324 10.1706 48.7324 10.7177C48.7324 11.2648 49.1759 11.7083 49.723 11.7083Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4935 12.018C23.9363 12.018 23.5029 12.4824 23.5029 13.0086C23.5029 13.5659 23.9673 13.9992 24.4935 13.9992H25.6389V11.9871H24.4935V12.018Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7841 13.9993C27.3413 13.9993 27.7747 13.5349 27.7747 13.0087C27.7747 12.4515 27.3103 12.0181 26.7841 12.0181H25.6387V14.0302H26.7841V13.9993Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3656 12.018C30.8084 12.018 30.375 12.4824 30.375 13.0086C30.375 13.5659 30.8393 13.9992 31.3656 13.9992H32.511V11.9871H31.3656V12.018Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6571 13.9993C34.2143 13.9993 34.6477 13.5349 34.6477 13.0087C34.6477 12.4515 34.1834 12.0181 33.6571 12.0181H32.5117V14.0302H33.6571V13.9993Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.142 13.9993C45.6891 13.9993 46.1326 13.5558 46.1326 13.0087C46.1326 12.4616 45.6891 12.0181 45.142 12.0181C44.5949 12.0181 44.1514 12.4616 44.1514 13.0087C44.1514 13.5558 44.5949 13.9993 45.142 13.9993Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2025 16.2898C22.7496 16.2898 23.1931 15.8463 23.1931 15.2992C23.1931 14.7521 22.7496 14.3086 22.2025 14.3086C21.6554 14.3086 21.2119 14.7521 21.2119 15.2992C21.2119 15.8463 21.6554 16.2898 22.2025 16.2898Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3656 16.2898C31.9127 16.2898 32.3562 15.8463 32.3562 15.2992C32.3562 14.7521 31.9127 14.3086 31.3656 14.3086C30.8185 14.3086 30.375 14.7521 30.375 15.2992C30.375 15.8463 30.8185 16.2898 31.3656 16.2898Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9476 14.3088C35.3904 14.3088 34.957 14.7731 34.957 15.2994C34.957 15.8257 35.4214 16.29 35.9476 16.29H37.093V14.2778H35.9476V14.3088Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2382 16.2898C38.7954 16.2898 39.2288 15.8255 39.2288 15.2992C39.2288 14.7729 38.7644 14.3086 38.2382 14.3086H37.0928V16.2898H38.2382Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.142 16.2898C45.6891 16.2898 46.1326 15.8463 46.1326 15.2992C46.1326 14.7521 45.6891 14.3086 45.142 14.3086C44.5949 14.3086 44.1514 14.7521 44.1514 15.2992C44.1514 15.8463 44.5949 16.2898 45.142 16.2898Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.723 16.2898C50.2701 16.2898 50.7136 15.8463 50.7136 15.2992C50.7136 14.7521 50.2701 14.3086 49.723 14.3086C49.1759 14.3086 48.7324 14.7521 48.7324 15.2992C48.7324 15.8463 49.1759 16.2898 49.723 16.2898Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2025 18.5806C22.7496 18.5806 23.1931 18.1371 23.1931 17.59C23.1931 17.0429 22.7496 16.5994 22.2025 16.5994C21.6554 16.5994 21.2119 17.0429 21.2119 17.59C21.2119 18.1371 21.6554 18.5806 22.2025 18.5806Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7846 18.5806C27.3317 18.5806 27.7752 18.1371 27.7752 17.59C27.7752 17.0429 27.3317 16.5994 26.7846 16.5994C26.2375 16.5994 25.7939 17.0429 25.7939 17.59C25.7939 18.1371 26.2375 18.5806 26.7846 18.5806Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3656 18.5806C31.9127 18.5806 32.3562 18.1371 32.3562 17.59C32.3562 17.0429 31.9127 16.5994 31.3656 16.5994C30.8185 16.5994 30.375 17.0429 30.375 17.59C30.375 18.1371 30.8185 18.5806 31.3656 18.5806Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9476 18.5806C36.4947 18.5806 36.9383 18.1371 36.9383 17.59C36.9383 17.0429 36.4947 16.5994 35.9476 16.5994C35.4005 16.5994 34.957 17.0429 34.957 17.59C34.957 18.1371 35.4005 18.5806 35.9476 18.5806Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5287 18.5806C41.0758 18.5806 41.5193 18.1371 41.5193 17.59C41.5193 17.0429 41.0758 16.5994 40.5287 16.5994C39.9816 16.5994 39.5381 17.0429 39.5381 17.59C39.5381 18.1371 39.9816 18.5806 40.5287 18.5806Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.142 18.5806C45.6891 18.5806 46.1326 18.1371 46.1326 17.59C46.1326 17.0429 45.6891 16.5994 45.142 16.5994C44.5949 16.5994 44.1514 17.0429 44.1514 17.59C44.1514 18.1371 44.5949 18.5806 45.142 18.5806Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.723 18.5806C50.2701 18.5806 50.7136 18.1371 50.7136 17.59C50.7136 17.0429 50.2701 16.5994 49.723 16.5994C49.1759 16.5994 48.7324 17.0429 48.7324 17.59C48.7324 18.1371 49.1759 18.5806 49.723 18.5806Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2025 18.8903C21.6453 18.8903 21.2119 19.3547 21.2119 19.8809C21.2119 20.4382 21.6763 20.8716 22.2025 20.8716H23.3479V18.8594H22.2025V18.8903Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6384 18.8904H23.3477V20.9026H25.6384V18.8904Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7841 20.8716C27.3413 20.8716 27.7747 20.4073 27.7747 19.881C27.7747 19.3238 27.3103 18.8904 26.7841 18.8904H25.6387V20.9026H26.7841V20.8716Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6566 20.8716C34.2037 20.8716 34.6472 20.4281 34.6472 19.881C34.6472 19.3339 34.2037 18.8904 33.6566 18.8904C33.1095 18.8904 32.666 19.3339 32.666 19.881C32.666 20.4281 33.1095 20.8716 33.6566 20.8716Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2387 18.8903C37.6814 18.8903 37.248 19.3547 37.248 19.8809C37.248 20.4382 37.7124 20.8716 38.2387 20.8716H39.3841V18.8594H38.2387V18.8903Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5292 20.8716C41.0864 20.8716 41.5198 20.4073 41.5198 19.881C41.5198 19.3238 41.0554 18.8904 40.5292 18.8904H39.3838V20.9026H40.5292V20.8716Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.142 18.8903C44.5848 18.8903 44.1514 19.3547 44.1514 19.8809C44.1514 20.4382 44.6157 20.8716 45.142 20.8716H46.2874V18.8594H45.142V18.8903Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5779 18.8904H46.2871V20.9026H48.5779V18.8904Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7235 20.8716C50.2807 20.8716 50.7141 20.4073 50.7141 19.881C50.7141 19.3238 50.2498 18.8904 49.7235 18.8904H48.5781V20.9026H49.7235V20.8716Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45839 21.1811C7.90117 21.1811 7.46777 21.6455 7.46777 22.1717C7.46777 22.698 7.93212 23.1623 8.45839 23.1623H9.60378V21.1501H8.45839V21.1811Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8943 21.1809H9.60352V23.1931H11.8943V21.1809Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0399 23.1621C13.5971 23.1621 14.0305 22.6978 14.0305 22.1715C14.0305 21.6453 13.5662 21.1809 13.0399 21.1809H11.8945V23.1931H13.0399V23.1621Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6215 23.1621C18.1686 23.1621 18.6121 22.7186 18.6121 22.1715C18.6121 21.6244 18.1686 21.1809 17.6215 21.1809C17.0744 21.1809 16.6309 21.6244 16.6309 22.1715C16.6309 22.7186 17.0744 23.1621 17.6215 23.1621Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2025 23.1621C22.7496 23.1621 23.1931 22.7186 23.1931 22.1715C23.1931 21.6244 22.7496 21.1809 22.2025 21.1809C21.6554 21.1809 21.2119 21.6244 21.2119 22.1715C21.2119 22.7186 21.6554 23.1621 22.2025 23.1621Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7846 21.1811C26.2273 21.1811 25.7939 21.6455 25.7939 22.1717C25.7939 22.698 26.2583 23.1623 26.7846 23.1623H27.93V21.1501H26.7846V21.1811Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2205 21.1809H27.9297V23.1931H30.2205V21.1809Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3661 23.1621C31.9233 23.1621 32.3567 22.6978 32.3567 22.1715C32.3567 21.6453 31.8924 21.1809 31.3661 21.1809H30.2207V23.1931H31.3661V23.1621Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5287 23.1621C41.0758 23.1621 41.5193 22.7186 41.5193 22.1715C41.5193 21.6244 41.0758 21.1809 40.5287 21.1809C39.9816 21.1809 39.5381 21.6244 39.5381 22.1715C39.5381 22.7186 39.9816 23.1621 40.5287 23.1621Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.142 23.1621C45.6891 23.1621 46.1326 22.7186 46.1326 22.1715C46.1326 21.6244 45.6891 21.1809 45.142 21.1809C44.5949 21.1809 44.1514 21.6244 44.1514 22.1715C44.1514 22.7186 44.5949 23.1621 45.142 23.1621Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.723 21.1811C49.1658 21.1811 48.7324 21.6455 48.7324 22.1717C48.7324 22.698 49.1968 23.1623 49.723 23.1623H50.8684V21.1501H49.723V21.1811Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.159 21.1809H50.8682V23.1931H53.159V21.1809Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.45 21.1809H53.1592V23.1931H55.45V21.1809Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5956 23.1621C57.1528 23.1621 57.5862 22.6978 57.5862 22.1715C57.5862 21.6453 57.1219 21.1809 56.5956 21.1809H55.4502V23.1931H56.5956V23.1621Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4682 21.1811C62.9109 21.1811 62.4775 21.6455 62.4775 22.1717C62.4775 22.698 62.9419 23.1623 63.4682 23.1623H64.6135V21.1501H63.4682V21.1811Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9041 21.1809H64.6133V23.1931H66.9041V21.1809Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0497 23.1621C68.6069 23.1621 69.0403 22.6978 69.0403 22.1715C69.0403 21.6453 68.576 21.1809 68.0497 21.1809H66.9043V23.1931H68.0497V23.1621Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87636 25.4531C4.42346 25.4531 4.86697 25.0096 4.86697 24.4625C4.86697 23.9154 4.42346 23.4719 3.87636 23.4719C3.32925 23.4719 2.88574 23.9154 2.88574 24.4625C2.88574 25.0096 3.32925 25.4531 3.87636 25.4531Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45839 23.4719C7.90117 23.4719 7.46777 23.9362 7.46777 24.4625C7.46777 25.0197 7.93212 25.4531 8.45839 25.4531H9.60378V23.4409H8.45839V23.4719Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8943 23.4719H9.60352V25.4841H11.8943V23.4719Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1853 23.4719H11.8945V25.4841H14.1853V23.4719Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.33 25.4842C15.8872 25.4842 16.3206 25.0198 16.3206 24.4935C16.3206 23.9363 15.8562 23.5029 15.33 23.5029H14.1846V25.5151H15.33V25.4842Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9115 25.4531C20.4586 25.4531 20.9021 25.0096 20.9021 24.4625C20.9021 23.9154 20.4586 23.4719 19.9115 23.4719C19.3644 23.4719 18.9209 23.9154 18.9209 24.4625C18.9209 25.0096 19.3644 25.4531 19.9115 25.4531Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.014 23.4719C51.4568 23.4719 51.0234 23.9362 51.0234 24.4625C51.0234 25.0197 51.4878 25.4531 52.014 25.4531H53.1594V23.4409H52.014V23.4719Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3046 25.4842C54.8618 25.4842 55.2952 25.0198 55.2952 24.4935C55.2952 23.9363 54.8308 23.5029 54.3046 23.5029H53.1592V25.5151H54.3046V25.4842Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8861 25.4531C59.4332 25.4531 59.8767 25.0096 59.8767 24.4625C59.8767 23.9154 59.4332 23.4719 58.8861 23.4719C58.339 23.4719 57.8955 23.9154 57.8955 24.4625C57.8955 25.0096 58.339 25.4531 58.8861 25.4531Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7592 23.4719C65.2019 23.4719 64.7686 23.9362 64.7686 24.4625C64.7686 25.0197 65.2329 25.4531 65.7592 25.4531H66.9046V23.4409H65.7592V23.4719Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0497 25.4842C68.6069 25.4842 69.0403 25.0198 69.0403 24.4935C69.0403 23.9363 68.576 23.5029 68.0497 23.5029H66.9043V25.5151H68.0497V25.4842Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16737 27.7439C6.71447 27.7439 7.15798 27.3004 7.15798 26.7533C7.15798 26.2062 6.71447 25.7627 6.16737 25.7627C5.62027 25.7627 5.17676 26.2062 5.17676 26.7533C5.17676 27.3004 5.62027 27.7439 6.16737 27.7439Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0394 25.7626C12.4822 25.7626 12.0488 26.227 12.0488 26.7533C12.0488 27.2795 12.5132 27.7439 13.0394 27.7439H14.1848V25.7317H13.0394V25.7626Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4754 25.7627H14.1846V27.7749H16.4754V25.7627Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7664 25.7627H16.4756V27.7749H18.7664V25.7627Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0574 25.7627H18.7666V27.7749H21.0574V25.7627Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.203 27.7749C22.7602 27.7749 23.1936 27.3106 23.1936 26.7843C23.1936 26.2581 22.7293 25.7937 22.203 25.7937H21.0576V27.8059H22.203V27.7749Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.723 27.7439C50.2701 27.7439 50.7136 27.3004 50.7136 26.7533C50.7136 26.2062 50.2701 25.7627 49.723 25.7627C49.1759 25.7627 48.7324 26.2062 48.7324 26.7533C48.7324 27.3004 49.1759 27.7439 49.723 27.7439Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4682 27.7439C64.0153 27.7439 64.4588 27.3004 64.4588 26.7533C64.4588 26.2062 64.0153 25.7627 63.4682 25.7627C62.9211 25.7627 62.4775 26.2062 62.4775 26.7533C62.4775 27.3004 62.9211 27.7439 63.4682 27.7439Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0394 28.0535C12.4822 28.0535 12.0488 28.5178 12.0488 29.0441C12.0488 29.5703 12.5132 30.0347 13.0394 30.0347H14.1848V28.0535H13.0394Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.33 30.0657C15.8872 30.0657 16.3206 29.6013 16.3206 29.0751C16.3206 28.5488 15.8562 28.0845 15.33 28.0845H14.1846V30.0967H15.33V30.0657Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9115 30.0347C20.4586 30.0347 20.9021 29.5912 20.9021 29.0441C20.9021 28.497 20.4586 28.0535 19.9115 28.0535C19.3644 28.0535 18.9209 28.497 18.9209 29.0441C18.9209 29.5912 19.3644 30.0347 19.9115 30.0347Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.723 30.0347C50.2701 30.0347 50.7136 29.5912 50.7136 29.0441C50.7136 28.497 50.2701 28.0535 49.723 28.0535C49.1759 28.0535 48.7324 28.497 48.7324 29.0441C48.7324 29.5912 49.1759 30.0347 49.723 30.0347Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3051 28.0535C53.7478 28.0535 53.3145 28.5178 53.3145 29.0441C53.3145 29.5703 53.7788 30.0347 54.3051 30.0347H55.4505V28.0535H54.3051Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.741 28.0535H55.4502V30.0656H57.741V28.0535Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.032 28.0535H57.7412V30.0656H60.032V28.0535Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.322 28.0535H60.0312V30.0656H62.322V28.0535Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4677 30.0657C64.0249 30.0657 64.4583 29.6013 64.4583 29.0751C64.4583 28.5488 63.9939 28.0845 63.4677 28.0845H62.3223V30.0967H63.4677V30.0657Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87636 30.3442C3.31914 30.3442 2.88574 30.8085 2.88574 31.3348C2.88574 31.892 3.35009 32.3254 3.87636 32.3254H5.02175V30.3132H3.87636V30.3442Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16688 32.3565C6.7241 32.3565 7.15749 31.8921 7.15749 31.3659C7.15749 30.8086 6.69314 30.3752 6.16688 30.3752H5.02148V32.3874H6.16688V32.3565Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3305 30.3442C14.7732 30.3442 14.3398 30.8085 14.3398 31.3348C14.3398 31.892 14.8042 32.3254 15.3305 32.3254H16.4759V30.3132H15.3305V30.3442Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7664 30.3442H16.4756V32.3564H18.7664V30.3442Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.912 32.3565C20.4692 32.3565 20.9026 31.8921 20.9026 31.3659C20.9026 30.8086 20.4383 30.3752 19.912 30.3752H18.7666V32.3874H19.912V32.3565Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.723 30.3442C49.1658 30.3442 48.7324 30.8085 48.7324 31.3348C48.7324 31.892 49.1968 32.3254 49.723 32.3254H50.8684V30.3132H49.723V30.3442Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0136 32.3565C52.5708 32.3565 53.0042 31.8921 53.0042 31.3659C53.0042 30.8086 52.5398 30.3752 52.0136 30.3752H50.8682V32.3874H52.0136V32.3565Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8861 32.3255C59.4332 32.3255 59.8767 31.882 59.8767 31.3348C59.8767 30.7877 59.4332 30.3442 58.8861 30.3442C58.339 30.3442 57.8955 30.7877 57.8955 31.3348C57.8955 31.882 58.339 32.3255 58.8861 32.3255Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4682 30.3442C62.9109 30.3442 62.4775 30.8085 62.4775 31.3348C62.4775 31.892 62.9419 32.3254 63.4682 32.3254H64.6135V30.3132H63.4682V30.3442Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7587 32.3565C66.3159 32.3565 66.7493 31.8921 66.7493 31.3659C66.7493 30.8086 66.2849 30.3752 65.7587 30.3752H64.6133V32.3874H65.7587V32.3565Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87636 34.6162C4.42346 34.6162 4.86697 34.1727 4.86697 33.6256C4.86697 33.0785 4.42346 32.635 3.87636 32.635C3.32925 32.635 2.88574 33.0785 2.88574 33.6256C2.88574 34.1727 3.32925 34.6162 3.87636 34.6162Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9115 32.635C19.3543 32.635 18.9209 33.0993 18.9209 33.6256C18.9209 34.1828 19.3852 34.6162 19.9115 34.6162H21.0569V32.604H19.9115V32.635Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.203 34.6472C22.7602 34.6472 23.1936 34.1829 23.1936 33.6566C23.1936 33.0994 22.7293 32.666 22.203 32.666H21.0576V34.6782H22.203V34.6472Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.723 34.6162C50.2701 34.6162 50.7136 34.1727 50.7136 33.6256C50.7136 33.0785 50.2701 32.635 49.723 32.635C49.1759 32.635 48.7324 33.0785 48.7324 33.6256C48.7324 34.1727 49.1759 34.6162 49.723 34.6162Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3051 34.6162C54.8522 34.6162 55.2957 34.1727 55.2957 33.6256C55.2957 33.0785 54.8522 32.635 54.3051 32.635C53.758 32.635 53.3145 33.0785 53.3145 33.6256C53.3145 34.1727 53.758 34.6162 54.3051 34.6162Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8861 32.635C58.3289 32.635 57.8955 33.0993 57.8955 33.6256C57.8955 34.1828 58.3599 34.6162 58.8861 34.6162H60.0315V32.604H58.8861V32.635Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1766 34.6472C61.7339 34.6472 62.1673 34.1829 62.1673 33.6566C62.1673 33.0994 61.7029 32.666 61.1766 32.666H60.0312V34.6782H61.1766V34.6472Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0492 34.6162C68.5963 34.6162 69.0398 34.1727 69.0398 33.6256C69.0398 33.0785 68.5963 32.635 68.0492 32.635C67.5021 32.635 67.0586 33.0785 67.0586 33.6256C67.0586 34.1727 67.5021 34.6162 68.0492 34.6162Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16737 36.907C6.71447 36.907 7.15798 36.4635 7.15798 35.9164C7.15798 35.3693 6.71447 34.9258 6.16737 34.9258C5.62027 34.9258 5.17676 35.3693 5.17676 35.9164C5.17676 36.4635 5.62027 36.907 6.16737 36.907Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7484 34.9257C10.1912 34.9257 9.75781 35.3901 9.75781 35.9163C9.75781 36.4736 10.2222 36.907 10.7484 36.907H11.8938V34.8948H10.7484V34.9257Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0399 36.938C13.5971 36.938 14.0305 36.4737 14.0305 35.9474C14.0305 35.3902 13.5662 34.9568 13.0399 34.9568H11.8945V36.969H13.0399V36.938Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6215 34.9257C17.0643 34.9257 16.6309 35.3901 16.6309 35.9163C16.6309 36.4736 17.0952 36.907 17.6215 36.907H18.7669V34.8948H17.6215V34.9257Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0574 34.9258H18.7666V36.938H21.0574V34.9258Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.203 36.938C22.7602 36.938 23.1936 36.4737 23.1936 35.9474C23.1936 35.3902 22.7293 34.9568 22.203 34.9568H21.0576V36.969H22.203V36.938Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5951 36.907C57.1422 36.907 57.5857 36.4635 57.5857 35.9164C57.5857 35.3693 57.1422 34.9258 56.5951 34.9258C56.048 34.9258 55.6045 35.3693 55.6045 35.9164C55.6045 36.4635 56.048 36.907 56.5951 36.907Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4682 36.907C64.0153 36.907 64.4588 36.4635 64.4588 35.9164C64.4588 35.3693 64.0153 34.9258 63.4682 34.9258C62.9211 34.9258 62.4775 35.3693 62.4775 35.9164C62.4775 36.4635 62.9211 36.907 63.4682 36.907Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0492 36.907C68.5963 36.907 69.0398 36.4635 69.0398 35.9164C69.0398 35.3693 68.5963 34.9258 68.0492 34.9258C67.5021 34.9258 67.0586 35.3693 67.0586 35.9164C67.0586 36.4635 67.5021 36.907 68.0492 36.907Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87636 37.2165C3.31914 37.2165 2.88574 37.6809 2.88574 38.2071C2.88574 38.7334 3.35009 39.1977 3.87636 39.1977H5.02175V37.1855H3.87636V37.2165Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.31228 37.2166H5.02148V39.2287H7.31228V37.2166Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4579 39.2288C9.01512 39.2288 9.44851 38.7644 9.44851 38.2382C9.44851 37.7119 8.98416 37.2476 8.4579 37.2476H7.3125V39.2597H8.4579V39.2288Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0394 37.2165C12.4822 37.2165 12.0488 37.6809 12.0488 38.2071C12.0488 38.7334 12.5132 39.1977 13.0394 39.1977H14.1848V37.1855H13.0394V37.2165Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.33 39.2288C15.8872 39.2288 16.3206 38.7644 16.3206 38.2382C16.3206 37.7119 15.8562 37.2476 15.33 37.2476H14.1846V39.2597H15.33V39.2288Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9115 39.1978C20.4586 39.1978 20.9021 38.7543 20.9021 38.2072C20.9021 37.6601 20.4586 37.2166 19.9115 37.2166C19.3644 37.2166 18.9209 37.6601 18.9209 38.2072C18.9209 38.7543 19.3644 39.1978 19.9115 39.1978Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.014 37.2165C51.4568 37.2165 51.0234 37.6809 51.0234 38.2071C51.0234 38.7334 51.4878 39.1977 52.014 39.1977H53.1594V37.1855H52.014V37.2165Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.45 37.2166H53.1592V39.2287H55.45V37.2166Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.741 37.2166H55.4502V39.2287H57.741V37.2166Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8866 39.2288C59.4438 39.2288 59.8772 38.7644 59.8772 38.2382C59.8772 37.7119 59.4129 37.2476 58.8866 37.2476H57.7412V39.2597H58.8866V39.2288Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4682 37.2165C62.9109 37.2165 62.4775 37.6809 62.4775 38.2071C62.4775 38.7334 62.9419 39.1977 63.4682 39.1977H64.6135V37.1855H63.4682V37.2165Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.9041 37.2166H64.6133V39.2287H66.9041V37.2166Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0497 39.2288C68.6069 39.2288 69.0403 38.7644 69.0403 38.2382C69.0403 37.7119 68.576 37.2476 68.0497 37.2476H66.9043V39.2597H68.0497V39.2288Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87636 39.5076C3.31914 39.5076 2.88574 39.9719 2.88574 40.4982C2.88574 41.0244 3.35009 41.4888 3.87636 41.4888H5.02175V39.5076H3.87636Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.16688 41.5196C6.7241 41.5196 7.15749 41.0552 7.15749 40.5289C7.15749 40.0027 6.69314 39.5383 6.16688 39.5383H5.02148V41.5505H6.16688V41.5196Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7484 41.4888C11.2955 41.4888 11.739 41.0453 11.739 40.4982C11.739 39.9511 11.2955 39.5076 10.7484 39.5076C10.2013 39.5076 9.75781 39.9511 9.75781 40.4982C9.75781 41.0453 10.2013 41.4888 10.7484 41.4888Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3305 39.5076C14.7732 39.5076 14.3398 39.9719 14.3398 40.4982C14.3398 41.0244 14.8042 41.4888 15.3305 41.4888H16.4759V39.5076H15.3305Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7664 39.5076H16.4756V41.5198H18.7664V39.5076Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.912 41.5196C20.4692 41.5196 20.9026 41.0552 20.9026 40.5289C20.9026 40.0027 20.4383 39.5383 19.912 39.5383H18.7666V41.5505H19.912V41.5196Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5951 41.4888C57.1422 41.4888 57.5857 41.0453 57.5857 40.4982C57.5857 39.9511 57.1422 39.5076 56.5951 39.5076C56.048 39.5076 55.6045 39.9511 55.6045 40.4982C55.6045 41.0453 56.048 41.4888 56.5951 41.4888Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87636 43.7793C4.42346 43.7793 4.86697 43.3358 4.86697 42.7887C4.86697 42.2416 4.42346 41.7981 3.87636 41.7981C3.32925 41.7981 2.88574 42.2416 2.88574 42.7887C2.88574 43.3358 3.32925 43.7793 3.87636 43.7793Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45839 43.7793C9.00549 43.7793 9.449 43.3358 9.449 42.7887C9.449 42.2416 9.00549 41.7981 8.45839 41.7981C7.91129 41.7981 7.46777 42.2416 7.46777 42.7887C7.46777 43.3358 7.91129 43.7793 8.45839 43.7793Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.723 41.798C49.1658 41.798 48.7324 42.2624 48.7324 42.7887C48.7324 43.3149 49.1968 43.7793 49.723 43.7793H50.8684V41.7671H49.723V41.798Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0136 43.8103C52.5708 43.8103 53.0042 43.346 53.0042 42.8197C53.0042 42.2935 52.5398 41.8291 52.0136 41.8291H50.8682V43.8413H52.0136V43.8103Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5951 43.7793C57.1422 43.7793 57.5857 43.3358 57.5857 42.7887C57.5857 42.2416 57.1422 41.7981 56.5951 41.7981C56.048 41.7981 55.6045 42.2416 55.6045 42.7887C55.6045 43.3358 56.048 43.7793 56.5951 43.7793Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1771 43.7793C61.7242 43.7793 62.1677 43.3358 62.1677 42.7887C62.1677 42.2416 61.7242 41.7981 61.1771 41.7981C60.63 41.7981 60.1865 42.2416 60.1865 42.7887C60.1865 43.3358 60.63 43.7793 61.1771 43.7793Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7592 43.7793C66.3063 43.7793 66.7498 43.3358 66.7498 42.7887C66.7498 42.2416 66.3063 41.7981 65.7592 41.7981C65.2121 41.7981 64.7686 42.2416 64.7686 42.7887C64.7686 43.3358 65.2121 43.7793 65.7592 43.7793Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87636 46.1013C4.42346 46.1013 4.86697 45.6578 4.86697 45.1107C4.86697 44.5636 4.42346 44.1201 3.87636 44.1201C3.32925 44.1201 2.88574 44.5636 2.88574 45.1107C2.88574 45.6578 3.32925 46.1013 3.87636 46.1013Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7484 44.0891C10.1912 44.0891 9.75781 44.5534 9.75781 45.0797C9.75781 45.6059 10.2222 46.0703 10.7484 46.0703H11.8938V44.0581H10.7484V44.0891Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0399 46.1013C13.5971 46.1013 14.0305 45.637 14.0305 45.1107C14.0305 44.5845 13.5662 44.1201 13.0399 44.1201H11.8945V46.1323H13.0399V46.1013Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6215 44.0891C17.0643 44.0891 16.6309 44.5534 16.6309 45.0797C16.6309 45.6059 17.0952 46.0703 17.6215 46.0703H18.7669V44.0581H17.6215V44.0891Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0574 44.0891H18.7666V46.1013H21.0574V44.0891Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.203 46.1013C22.7602 46.1013 23.1936 45.637 23.1936 45.1107C23.1936 44.5845 22.7293 44.1201 22.203 44.1201H21.0576V46.1323H22.203V46.1013Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.014 46.1013C52.5611 46.1013 53.0047 45.6578 53.0047 45.1107C53.0047 44.5636 52.5611 44.1201 52.014 44.1201C51.4669 44.1201 51.0234 44.5636 51.0234 45.1107C51.0234 45.6578 51.4669 46.1013 52.014 46.1013Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4682 46.1013C64.0153 46.1013 64.4588 45.6578 64.4588 45.1107C64.4588 44.5636 64.0153 44.1201 63.4682 44.1201C62.9211 44.1201 62.4775 44.5636 62.4775 45.1107C62.4775 45.6578 62.9211 46.1013 63.4682 46.1013Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87636 48.3919C4.42346 48.3919 4.86697 47.9484 4.86697 47.4013C4.86697 46.8542 4.42346 46.4106 3.87636 46.4106C3.32925 46.4106 2.88574 46.8542 2.88574 47.4013C2.88574 47.9484 3.32925 48.3919 3.87636 48.3919Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.45839 46.3798C7.90117 46.3798 7.46777 46.8442 7.46777 47.3704C7.46777 47.9277 7.93212 48.3611 8.45839 48.3611H9.60378V46.3489H8.45839V46.3798Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7489 48.3919C11.3061 48.3919 11.7395 47.9275 11.7395 47.4013C11.7395 46.844 11.2752 46.4106 10.7489 46.4106H9.60352V48.4228H10.7489V48.3919Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3305 48.3919C15.8776 48.3919 16.3211 47.9484 16.3211 47.4013C16.3211 46.8542 15.8776 46.4106 15.3305 46.4106C14.7834 46.4106 14.3398 46.8542 14.3398 47.4013C14.3398 47.9484 14.7834 48.3919 15.3305 48.3919Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.723 48.3919C50.2701 48.3919 50.7136 47.9484 50.7136 47.4013C50.7136 46.8542 50.2701 46.4106 49.723 46.4106C49.1759 46.4106 48.7324 46.8542 48.7324 47.4013C48.7324 47.9484 49.1759 48.3919 49.723 48.3919Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3051 48.3919C54.8522 48.3919 55.2957 47.9484 55.2957 47.4013C55.2957 46.8542 54.8522 46.4106 54.3051 46.4106C53.758 46.4106 53.3145 46.8542 53.3145 47.4013C53.3145 47.9484 53.758 48.3919 54.3051 48.3919Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8861 46.3798C58.3289 46.3798 57.8955 46.8442 57.8955 47.3704C57.8955 47.9277 58.3599 48.3611 58.8861 48.3611H60.0315V46.3489H58.8861V46.3798Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1766 48.3919C61.7339 48.3919 62.1673 47.9275 62.1673 47.4013C62.1673 46.844 61.7029 46.4106 61.1766 46.4106H60.0312V48.4228H61.1766V48.3919Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7592 46.3798C65.2019 46.3798 64.7686 46.8442 64.7686 47.3704C64.7686 47.9277 65.2329 48.3611 65.7592 48.3611H66.9046V46.3489H65.7592V46.3798Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0497 48.3919C68.6069 48.3919 69.0403 47.9275 69.0403 47.4013C69.0403 46.844 68.576 46.4106 68.0497 46.4106H66.9043V48.4228H68.0497V48.3919Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.87636 50.6826C4.42346 50.6826 4.86697 50.2391 4.86697 49.692C4.86697 49.1449 4.42346 48.7014 3.87636 48.7014C3.32925 48.7014 2.88574 49.1449 2.88574 49.692C2.88574 50.2391 3.32925 50.6826 3.87636 50.6826Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7484 50.6826C11.2955 50.6826 11.739 50.2391 11.739 49.692C11.739 49.1449 11.2955 48.7014 10.7484 48.7014C10.2013 48.7014 9.75781 49.1449 9.75781 49.692C9.75781 50.2391 10.2013 50.6826 10.7484 50.6826Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6215 50.6826C18.1686 50.6826 18.6121 50.2391 18.6121 49.692C18.6121 49.1449 18.1686 48.7014 17.6215 48.7014C17.0744 48.7014 16.6309 49.1449 16.6309 49.692C16.6309 50.2391 17.0744 50.6826 17.6215 50.6826Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0746 48.6706C28.5174 48.6706 28.084 49.135 28.084 49.6612C28.084 50.1875 28.5483 50.6518 29.0746 50.6518H30.22V48.6396H29.0746V48.6706Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5115 48.6704H30.2207V50.6826H32.5115V48.6704Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6571 50.6826C34.2143 50.6826 34.6477 50.2183 34.6477 49.692C34.6477 49.1658 34.1834 48.7014 33.6571 48.7014H32.5117V50.7136H33.6571V50.6826Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2387 50.6826C38.7858 50.6826 39.2293 50.2391 39.2293 49.692C39.2293 49.1449 38.7858 48.7014 38.2387 48.7014C37.6916 48.7014 37.248 49.1449 37.248 49.692C37.248 50.2391 37.6916 50.6826 38.2387 50.6826Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.142 50.6826C45.6891 50.6826 46.1326 50.2391 46.1326 49.692C46.1326 49.1449 45.6891 48.7014 45.142 48.7014C44.5949 48.7014 44.1514 49.1449 44.1514 49.692C44.1514 50.2391 44.5949 50.6826 45.142 50.6826Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.723 48.6706C49.1658 48.6706 48.7324 49.135 48.7324 49.6612C48.7324 50.1875 49.1968 50.6518 49.723 50.6518H50.8684V48.6396H49.723V48.6706Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.159 48.6704H50.8682V50.6826H53.159V48.6704Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.45 48.6704H53.1592V50.6826H55.45V48.6704Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.741 48.6704H55.4502V50.6826H57.741V48.6704Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8866 50.6826C59.4438 50.6826 59.8772 50.2183 59.8772 49.692C59.8772 49.1658 59.4129 48.7014 58.8866 48.7014H57.7412V50.7136H58.8866V50.6826Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7592 48.6706C65.2019 48.6706 64.7686 49.135 64.7686 49.6612C64.7686 50.1875 65.2329 50.6518 65.7592 50.6518H66.9046V48.6396H65.7592V48.6706Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0497 50.6826C68.6069 50.6826 69.0403 50.2183 69.0403 49.692C69.0403 49.1658 68.576 48.7014 68.0497 48.7014H66.9043V50.7136H68.0497V50.6826Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2025 50.9614C21.6453 50.9614 21.2119 51.4258 21.2119 51.952C21.2119 52.4783 21.6763 52.9426 22.2025 52.9426H23.3479V50.9614H22.2025Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4931 52.9737C25.0503 52.9737 25.4837 52.5093 25.4837 51.983C25.4837 51.4568 25.0193 50.9924 24.4931 50.9924H23.3477V53.0046H24.4931V52.9737Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3656 52.9737C31.9127 52.9737 32.3562 52.5301 32.3562 51.983C32.3562 51.4359 31.9127 50.9924 31.3656 50.9924C30.8185 50.9924 30.375 51.4359 30.375 51.983C30.375 52.5301 30.8185 52.9737 31.3656 52.9737Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9476 50.9614C35.3904 50.9614 34.957 51.4258 34.957 51.952C34.957 52.4783 35.4214 52.9426 35.9476 52.9426H37.093V50.9614H35.9476Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3836 50.9614H37.0928V52.9736H39.3836V50.9614Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6746 50.9614H39.3838V52.9736H41.6746V50.9614Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9656 50.9614H41.6748V52.9736H43.9656V50.9614Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2869 50.9614H43.9961V52.9736H46.2869V50.9614Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5779 50.9614H46.2871V52.9736H48.5779V50.9614Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7235 52.9737C50.2807 52.9737 50.7141 52.5093 50.7141 51.983C50.7141 51.4568 50.2498 50.9924 49.7235 50.9924H48.5781V53.0046H49.7235V52.9737Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8861 50.9614C58.3289 50.9614 57.8955 51.4258 57.8955 51.952C57.8955 52.4783 58.3599 52.9426 58.8861 52.9426H60.0315V50.9614H58.8861Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1766 52.9737C61.7339 52.9737 62.1673 52.5093 62.1673 51.983C62.1673 51.4568 61.7029 50.9924 61.1766 50.9924H60.0312V53.0046H61.1766V52.9737Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0492 52.9737C68.5963 52.9737 69.0398 52.5301 69.0398 51.983C69.0398 51.4359 68.5963 50.9924 68.0492 50.9924C67.5021 50.9924 67.0586 51.4359 67.0586 51.983C67.0586 52.5301 67.5021 52.9737 68.0492 52.9737Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4935 55.2642C25.0406 55.2642 25.4842 54.8207 25.4842 54.2736C25.4842 53.7265 25.0406 53.283 24.4935 53.283C23.9464 53.283 23.5029 53.7265 23.5029 54.2736C23.5029 54.8207 23.9464 55.2642 24.4935 55.2642Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6566 55.2642C34.2037 55.2642 34.6472 54.8207 34.6472 54.2736C34.6472 53.7265 34.2037 53.283 33.6566 53.283C33.1095 53.283 32.666 53.7265 32.666 54.2736C32.666 54.8207 33.1095 55.2642 33.6566 55.2642Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8197 55.2642C43.3668 55.2642 43.8103 54.8207 43.8103 54.2736C43.8103 53.7265 43.3668 53.283 42.8197 53.283C42.2726 53.283 41.8291 53.7265 41.8291 54.2736C41.8291 54.8207 42.2726 55.2642 42.8197 55.2642Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.432 53.2521C46.8748 53.2521 46.4414 53.7165 46.4414 54.2428C46.4414 54.769 46.9058 55.2334 47.432 55.2334H48.5774V53.2212H47.432V53.2521Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7235 55.2642C50.2807 55.2642 50.7141 54.7998 50.7141 54.2736C50.7141 53.7473 50.2498 53.283 49.7235 53.283H48.5781V55.2951H49.7235V55.2642Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3051 55.2642C54.8522 55.2642 55.2957 54.8207 55.2957 54.2736C55.2957 53.7265 54.8522 53.283 54.3051 53.283C53.758 53.283 53.3145 53.7265 53.3145 54.2736C53.3145 54.8207 53.758 55.2642 54.3051 55.2642Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8861 53.2521C58.3289 53.2521 57.8955 53.7165 57.8955 54.2428C57.8955 54.769 58.3599 55.2334 58.8861 55.2334H60.0315V53.2212H58.8861V53.2521Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.322 53.252H60.0312V55.2641H62.322V53.252Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6131 53.252H62.3223V55.2641H64.6131V53.252Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7587 55.2642C66.3159 55.2642 66.7493 54.7998 66.7493 54.2736C66.7493 53.7473 66.2849 53.283 65.7587 53.283H64.6133V55.2951H65.7587V55.2642Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9476 57.5552C36.4947 57.5552 36.9383 57.1117 36.9383 56.5646C36.9383 56.0175 36.4947 55.574 35.9476 55.574C35.4005 55.574 34.957 56.0175 34.957 56.5646C34.957 57.1117 35.4005 57.5552 35.9476 57.5552Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8197 57.5552C43.3668 57.5552 43.8103 57.1117 43.8103 56.5646C43.8103 56.0175 43.3668 55.574 42.8197 55.574C42.2726 55.574 41.8291 56.0175 41.8291 56.5646C41.8291 57.1117 42.2726 57.5552 42.8197 57.5552Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.432 55.5429C46.8748 55.5429 46.4414 56.0073 46.4414 56.5335C46.4414 57.0598 46.9058 57.5241 47.432 57.5241H48.5774V55.512H47.432V55.5429Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7235 57.5552C50.2807 57.5552 50.7141 57.0909 50.7141 56.5646C50.7141 56.0383 50.2498 55.574 49.7235 55.574H48.5781V57.5862H49.7235V57.5552Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8861 55.5429C58.3289 55.5429 57.8955 56.0073 57.8955 56.5335C57.8955 57.0598 58.3599 57.5241 58.8861 57.5241H60.0315V55.512H58.8861V55.5429Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1766 57.5552C61.7339 57.5552 62.1673 57.0909 62.1673 56.5646C62.1673 56.0383 61.7029 55.574 61.1766 55.574H60.0312V57.5862H61.1766V57.5552Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7592 55.5429C65.2019 55.5429 64.7686 56.0073 64.7686 56.5335C64.7686 57.0598 65.2329 57.5241 65.7592 57.5241H66.9046V55.512H65.7592V55.5429Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0497 57.5552C68.6069 57.5552 69.0403 57.0909 69.0403 56.5646C69.0403 56.0383 68.576 55.574 68.0497 55.574H66.9043V57.5862H68.0497V57.5552Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2025 59.846C22.7496 59.846 23.1931 59.4025 23.1931 58.8554C23.1931 58.3083 22.7496 57.8647 22.2025 57.8647C21.6554 57.8647 21.2119 58.3083 21.2119 58.8554C21.2119 59.4025 21.6554 59.846 22.2025 59.846Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0746 59.846C29.6217 59.846 30.0652 59.4025 30.0652 58.8554C30.0652 58.3083 29.6217 57.8647 29.0746 57.8647C28.5275 57.8647 28.084 58.3083 28.084 58.8554C28.084 59.4025 28.5275 59.846 29.0746 59.846Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6566 59.846C34.2037 59.846 34.6472 59.4025 34.6472 58.8554C34.6472 58.3083 34.2037 57.8647 33.6566 57.8647C33.1095 57.8647 32.666 58.3083 32.666 58.8554C32.666 59.4025 33.1095 59.846 33.6566 59.846Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2387 57.8337C37.6814 57.8337 37.248 58.298 37.248 58.8243C37.248 59.3815 37.7124 59.8149 38.2387 59.8149H39.3841V57.8027H38.2387V57.8337Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5292 59.846C41.0864 59.846 41.5198 59.3816 41.5198 58.8554C41.5198 58.2981 41.0554 57.8647 40.5292 57.8647H39.3838V59.8769H40.5292V59.846Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.432 57.8337C46.8748 57.8337 46.4414 58.298 46.4414 58.8243C46.4414 59.3815 46.9058 59.8149 47.432 59.8149H48.5774V57.8027H47.432V57.8337Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8689 57.8337H48.5781V59.8459H50.8689V57.8337Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.159 57.8337H50.8682V59.8459H53.159V57.8337Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.45 57.8337H53.1592V59.8459H55.45V57.8337Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.741 57.8337H55.4502V59.8459H57.741V57.8337Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8866 59.846C59.4438 59.846 59.8772 59.3816 59.8772 58.8554C59.8772 58.2981 59.4129 57.8647 58.8866 57.8647H57.7412V59.8769H58.8866V59.846Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2025 60.1245C21.6453 60.1245 21.2119 60.5888 21.2119 61.1151C21.2119 61.6723 21.6763 62.1057 22.2025 62.1057H23.3479V60.0935H22.2025V60.1245Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4931 62.1367C25.0503 62.1367 25.4837 61.6724 25.4837 61.1461C25.4837 60.5889 25.0193 60.1555 24.4931 60.1555H23.3477V62.1677H24.4931V62.1367Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0746 60.1245C28.5174 60.1245 28.084 60.5888 28.084 61.1151C28.084 61.6723 28.5483 62.1057 29.0746 62.1057H30.22V60.0935H29.0746V60.1245Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5115 60.1245H30.2207V62.1367H32.5115V60.1245Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6571 62.1367C34.2143 62.1367 34.6477 61.6724 34.6477 61.1461C34.6477 60.5889 34.1834 60.1555 33.6571 60.1555H32.5117V62.1677H33.6571V62.1367Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8197 60.1245C42.2625 60.1245 41.8291 60.5888 41.8291 61.1151C41.8291 61.6723 42.2935 62.1057 42.8197 62.1057H43.9651V60.0935H42.8197V60.1245Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1415 62.1367C45.6987 62.1367 46.1321 61.6724 46.1321 61.1461C46.1321 60.5889 45.6678 60.1555 45.1415 60.1555H43.9961V62.1677H45.1415V62.1367Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.723 60.1245C49.1658 60.1245 48.7324 60.5888 48.7324 61.1151C48.7324 61.6723 49.1968 62.1057 49.723 62.1057H50.8684V60.0935H49.723V60.1245Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.159 60.1245H50.8682V62.1367H53.159V60.1245Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3046 62.1367C54.8618 62.1367 55.2952 61.6724 55.2952 61.1461C55.2952 60.5889 54.8308 60.1555 54.3046 60.1555H53.1592V62.1677H54.3046V62.1367Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8861 60.1245C58.3289 60.1245 57.8955 60.5888 57.8955 61.1151C57.8955 61.6723 58.3599 62.1057 58.8861 62.1057H60.0315V60.0935H58.8861V60.1245Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1766 62.1367C61.7339 62.1367 62.1673 61.6724 62.1673 61.1461C62.1673 60.5889 61.7029 60.1555 61.1766 60.1555H60.0312V62.1677H61.1766V62.1367Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2025 62.4153C21.6453 62.4153 21.2119 62.8796 21.2119 63.4059C21.2119 63.9322 21.6763 64.3965 22.2025 64.3965H23.3479V62.4153H22.2025Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4931 64.4275C25.0503 64.4275 25.4837 63.9632 25.4837 63.4369C25.4837 62.9106 25.0193 62.4463 24.4931 62.4463H23.3477V64.4585H24.4931V64.4275Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6566 62.4153C33.0994 62.4153 32.666 62.8796 32.666 63.4059C32.666 63.9322 33.1304 64.3965 33.6566 64.3965H34.802V62.4153H33.6566Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9472 64.4275C36.5044 64.4275 36.9378 63.9632 36.9378 63.4369C36.9378 62.9106 36.4734 62.4463 35.9472 62.4463H34.8018V64.4585H35.9472V64.4275Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5287 62.4153C39.9715 62.4153 39.5381 62.8796 39.5381 63.4059C39.5381 63.9322 40.0024 64.3965 40.5287 64.3965H41.6741V62.4153H40.5287Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9656 62.4153H41.6748V64.4275H43.9656V62.4153Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1415 64.4275C45.6987 64.4275 46.1321 63.9632 46.1321 63.4369C46.1321 62.9106 45.6678 62.4463 45.1415 62.4463H43.9961V64.4585H45.1415V64.4275Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.014 62.4153C51.4568 62.4153 51.0234 62.8796 51.0234 63.4059C51.0234 63.9322 51.4878 64.3965 52.014 64.3965H53.1594V62.4153H52.014Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.45 62.4153H53.1592V64.4275H55.45V62.4153Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.741 62.4153H55.4502V64.4275H57.741V62.4153Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.8866 64.4275C59.4438 64.4275 59.8772 63.9632 59.8772 63.4369C59.8772 62.9106 59.4129 62.4463 58.8866 62.4463H57.7412V64.4585H58.8866V64.4275Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.4682 62.4153C62.9109 62.4153 62.4775 62.8796 62.4775 63.4059C62.4775 63.9322 62.9419 64.3965 63.4682 64.3965H64.6135V62.4153H63.4682Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7587 64.4275C66.3159 64.4275 66.7493 63.9632 66.7493 63.4369C66.7493 62.9106 66.2849 62.4463 65.7587 62.4463H64.6133V64.4585H65.7587V64.4275Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4935 66.7183C25.0406 66.7183 25.4842 66.2748 25.4842 65.7277C25.4842 65.1806 25.0406 64.7371 24.4935 64.7371C23.9464 64.7371 23.5029 65.1806 23.5029 65.7277C23.5029 66.2748 23.9464 66.7183 24.4935 66.7183Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9476 66.7183C36.4947 66.7183 36.9383 66.2748 36.9383 65.7277C36.9383 65.1806 36.4947 64.7371 35.9476 64.7371C35.4005 64.7371 34.957 65.1806 34.957 65.7277C34.957 66.2748 35.4005 66.7183 35.9476 66.7183Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8197 64.737C42.2625 64.737 41.8291 65.2014 41.8291 65.7276C41.8291 66.2539 42.2935 66.7182 42.8197 66.7182H43.9651V64.7061H42.8197V64.737Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1415 66.7183C45.6987 66.7183 46.1321 66.2539 46.1321 65.7277C46.1321 65.2014 45.6678 64.7371 45.1415 64.7371H43.9961V66.7492H45.1415V66.7183Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5951 66.7183C57.1422 66.7183 57.5857 66.2748 57.5857 65.7277C57.5857 65.1806 57.1422 64.7371 56.5951 64.7371C56.048 64.7371 55.6045 65.1806 55.6045 65.7277C55.6045 66.2748 56.048 66.7183 56.5951 66.7183Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1771 66.7183C61.7242 66.7183 62.1677 66.2748 62.1677 65.7277C62.1677 65.1806 61.7242 64.7371 61.1771 64.7371C60.63 64.7371 60.1865 65.1806 60.1865 65.7277C60.1865 66.2748 60.63 66.7183 61.1771 66.7183Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0492 66.7183C68.5963 66.7183 69.0398 66.2748 69.0398 65.7277C69.0398 65.1806 68.5963 64.7371 68.0492 64.7371C67.5021 64.7371 67.0586 65.1806 67.0586 65.7277C67.0586 66.2748 67.5021 66.7183 68.0492 66.7183Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7846 69.0091C27.3317 69.0091 27.7752 68.5655 27.7752 68.0184C27.7752 67.4713 27.3317 67.0278 26.7846 67.0278C26.2375 67.0278 25.7939 67.4713 25.7939 68.0184C25.7939 68.5655 26.2375 69.0091 26.7846 69.0091Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9476 67.0278C35.3904 67.0278 34.957 67.4921 34.957 68.0184C34.957 68.5447 35.4214 69.009 35.9476 69.009H37.093V66.9968H35.9476V67.0278Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.2382 69.0091C38.7954 69.0091 39.2288 68.5447 39.2288 68.0184C39.2288 67.4922 38.7644 67.0278 38.2382 67.0278H37.0928V69.04H38.2382V69.0091Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8197 67.0278C42.2625 67.0278 41.8291 67.4921 41.8291 68.0184C41.8291 68.5447 42.2935 69.009 42.8197 69.009H43.9651V66.9968H42.8197V67.0278Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2869 67.0278H43.9961V69.04H46.2869V67.0278Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.4325 69.0091C47.9897 69.0091 48.4231 68.5447 48.4231 68.0184C48.4231 67.4922 47.9588 67.0278 47.4325 67.0278H46.2871V69.04H47.4325V69.0091Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.014 69.0091C52.5611 69.0091 53.0047 68.5655 53.0047 68.0184C53.0047 67.4713 52.5611 67.0278 52.014 67.0278C51.4669 67.0278 51.0234 67.4713 51.0234 68.0184C51.0234 68.5655 51.4669 69.0091 52.014 69.0091Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5951 67.0278C56.0379 67.0278 55.6045 67.4921 55.6045 68.0184C55.6045 68.5447 56.0688 69.009 56.5951 69.009H57.7405V66.9968H56.5951V67.0278Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.032 67.0278H57.7412V69.04H60.032V67.0278Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1766 69.0091C61.7339 69.0091 62.1673 68.5447 62.1673 68.0184C62.1673 67.4922 61.7029 67.0278 61.1766 67.0278H60.0312V69.04H61.1766V69.0091Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1955 2.69995C2.91689 2.69995 2.7002 2.91665 2.7002 3.19526V4.99074V7.28154V9.57233V11.8631V14.1539V16.4447V18.2402C2.7002 18.5188 2.91689 18.7355 3.1955 18.7355H18.2714C18.55 18.7355 18.7667 18.5188 18.7667 18.2402V16.4447V14.1539V11.8631V9.57233V7.28154V4.99074V3.19526C18.7667 2.91665 18.55 2.69995 18.2714 2.69995H3.1955ZM16.4759 7.28154V9.57233V11.8631V14.1539V16.1661C16.4759 16.3209 16.3521 16.4447 16.1973 16.4447H5.30055C5.14577 16.4447 5.02194 16.3209 5.02194 16.1661V14.1539V11.8631V9.57233V7.28154V5.26935C5.02194 5.11457 5.14577 4.99074 5.30055 4.99074H16.1973C16.3521 4.99074 16.4759 5.11457 16.4759 5.26935V7.28154V7.28154Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1849 11.8631V9.57228V7.7768C14.1849 7.49819 13.9682 7.28149 13.6896 7.28149H7.80781C7.5292 7.28149 7.3125 7.49819 7.3125 7.7768V9.57228V11.8631V13.6586C7.3125 13.9372 7.5292 14.1539 7.80781 14.1539H13.7205C13.9991 14.1539 14.2158 13.9372 14.2158 13.6586V11.8631H14.1849Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.6232 2.69995C53.3446 2.69995 53.1279 2.91665 53.1279 3.19526V4.99074V7.28154V9.57233V11.8631V14.1539V16.4447V18.2402C53.1279 18.5188 53.3446 18.7355 53.6232 18.7355H68.6991C68.9777 18.7355 69.1944 18.5188 69.1944 18.2402V16.4447V14.1539V11.8631V9.57233V7.28154V4.99074V3.19526C69.1944 2.91665 68.9777 2.69995 68.6991 2.69995H53.6232ZM66.9036 7.28154V9.57233V11.8631V14.1539V16.1661C66.9036 16.3209 66.7798 16.4447 66.625 16.4447H55.7283C55.5735 16.4447 55.4497 16.3209 55.4497 16.1661V14.1539V11.8631V9.57233V7.28154V5.26935C55.4497 5.11457 55.5735 4.99074 55.7283 4.99074H66.625C66.7798 4.99074 66.9036 5.11457 66.9036 5.26935V7.28154V7.28154Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.6133 11.8631V9.57228V7.7768C64.6133 7.49819 64.3966 7.28149 64.118 7.28149H58.2053C57.9267 7.28149 57.71 7.49819 57.71 7.7768V9.57228V11.8631V13.6586C57.71 13.9372 57.9267 14.1539 58.2053 14.1539H64.118C64.3966 14.1539 64.6133 13.9372 64.6133 13.6586V11.8631Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1955 53.1284C2.91689 53.1284 2.7002 53.3451 2.7002 53.6237V55.4192V57.71V60.0008V62.2916V64.5824V66.8732V68.6687C2.7002 68.9473 2.91689 69.164 3.1955 69.164H18.2714C18.55 69.164 18.7667 68.9473 18.7667 68.6687V66.8732V64.5824V62.2916V60.0008V57.71V55.4192V53.6237C18.7667 53.3451 18.55 53.1284 18.2714 53.1284C18.2714 53.1284 3.1955 53.1284 3.1955 53.1284ZM16.4759 57.71V60.0008V62.2916V64.5824V66.5946C16.4759 66.7493 16.3521 66.8732 16.1973 66.8732H5.30055C5.14577 66.8732 5.02194 66.7493 5.02194 66.5946V64.5824V62.2916V60.0008V57.71V55.6978C5.02194 55.543 5.14577 55.4192 5.30055 55.4192H16.1973C16.3521 55.4192 16.4759 55.543 16.4759 55.6978V57.71V57.71Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1849 62.2915V60.0008V58.2053C14.1849 57.9267 13.9682 57.71 13.6896 57.71H7.80781C7.5292 57.71 7.3125 57.9267 7.3125 58.2053V60.0008V62.2915V64.087C7.3125 64.3656 7.5292 64.5823 7.80781 64.5823H13.7205C13.9991 64.5823 14.2158 64.3656 14.2158 64.087V62.2915H14.1849Z",
    fill: "#0D0A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0399 25.4221C30.2201 25.4221 25.5146 30.1275 25.5146 35.9474C25.5146 37.8667 26.0409 39.6622 26.9387 41.241L33.2229 37.619C32.9442 37.1237 32.7585 36.5665 32.7585 35.9783C32.7585 34.1519 34.2444 32.6969 36.0399 32.6969C37.8664 32.6969 39.3213 34.1829 39.3213 35.9783C39.3213 37.4952 38.2997 38.7954 36.8757 39.1669L38.7641 46.1631C43.2528 44.9558 46.5652 40.8695 46.5652 35.9783C46.5652 30.1275 41.8288 25.4221 36.0399 25.4221Z",
    fill: "#FFBE00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1924 37.5881L26.9082 41.2101C28.3013 43.5937 30.592 45.3892 33.2853 46.1012L35.1736 39.105C34.3378 38.8883 33.6258 38.3311 33.1924 37.5881Z",
    fill: "#0D0A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8822_140257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthenticatedQrCode);
export default __webpack_public_path__ + "static/media/authenticated-qr-code.94d13e03.svg";
export { ForwardRef as ReactComponent };